var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.handleSearch.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "inline-form-group" },
        [
          _c(
            "md-field",
            { staticClass: "search-member" },
            [
              _c("md-input", {
                attrs: { name: _vm.name, placeholder: _vm.placeholder },
                model: {
                  value: _vm.localSearch,
                  callback: function($$v) {
                    _vm.localSearch = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "localSearch"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "reset-btn md-button md-accent md-theme-default",
              attrs: {
                type: "button",
                title: "Clear",
                disabled: !_vm.localSearch
              },
              on: { click: _vm.handleClear }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "search-addon-btnstyle md-button md-accent card-header md-theme-default search-button",
        attrs: { type: "submit", title: "Search" }
      },
      [_c("i", { staticClass: "fa fa-search" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0eca37cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eca37cb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBar.vue
// module id = null
// module chunks = 